import { render } from "./Pastil.vue?vue&type=template&id=04c9c9d1&scoped=true"
import script from "./Pastil.vue?vue&type=script&lang=js"
export * from "./Pastil.vue?vue&type=script&lang=js"

import "./Pastil.vue?vue&type=style&index=0&id=04c9c9d1&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c9c9d1"]])

export default __exports__